import React from 'react'
import {Navigate, Route, Routes, useLocation} from '@startlibs/components'
import {LoginForm} from './pages/LoginForm'
import {SsoLogin} from './pages/SsoLogin'
import {UserNotFound} from './errors/UserNotFound'
import {AlreadyActivated} from './errors/AlreadyActivated'
import {UrlAccessDenied} from './errors/UrlAccessDenied'
import {AccessDenied} from './errors/AccessDenied'
import {DeletedAccountError} from './errors/DeletedAccountError'
import {LinkExpiredError} from './errors/LinkExpiredError'
import {RedefinePassword} from './pages/RedefinePassword'
import {PasswordRecovery} from './pages/PasswordRecovery'
import {Activate} from './pages/Activate'
import {ActivationSuccess} from './pages/ActivationSuccess'
import {EmailChangeFinish} from './pages/EmailChangeFinish'
import {AccountSettings} from './pages/AccountSettings'

export const AppRoutes = ({system, user, userToggle, token, autoLogin, assignState}) => {
  const location = useLocation()
  return (
    <Routes>
      {user.email && <Route path="/account">{() => <AccountSettings system={system} userToggle={userToggle}/>}</Route>}
      <Route path="/activate-success">{() => <ActivationSuccess token={token} system={system}/>}</Route>
      <Route path="/activate">{() => <Activate system={system}/>}</Route>
      <Route path="/account/email-change/finish">{() => <EmailChangeFinish system={system}/>}</Route>
      <Route path="/recovery">{() => <PasswordRecovery system={system}/>}</Route>
      <Route path="/redefine-password">{() => <RedefinePassword system={system}/>}</Route>
      <Route path="/reset">{() => <RedefinePassword system={system} autoLogin={autoLogin}/>}</Route>
      <Route path="/2fa">{() => <LoginForm system={system} userToggle={userToggle}/>}</Route>
      <Route path="/settings">{() => <LoginForm loginToSettings system={system} userToggle={userToggle}/>}</Route>
      <Route path="/error/linkexpired">{() => <LinkExpiredError system={system}/>}</Route>
      <Route path="/error/deleted-account">{() => <DeletedAccountError system={system}/>}</Route>
      <Route path="/error/access-denied">{() => <AccessDenied system={system}/>}</Route>
      <Route path="/error/url-access-denied">{() => <UrlAccessDenied system={system}/>}</Route>
      <Route path="/error/activated">{() => <AlreadyActivated system={system}/>}</Route>
      <Route path="/error/usernotfound">{() => <UserNotFound system={system}/>}</Route>
      <Route path="/change-email-success">{() => <LoginForm fromActivation system={system} userToggle={userToggle}/>}</Route>
      <Route path="/" exact key={location.state && location.state.loginKey}>{() =>
        <LoginForm
          userToggle={userToggle}
          needsRegistration={(idToken,username) => assignState({needsRegistration: idToken, registrationValues: {username}})} system={system}
        />
      }</Route>
      <Route path="/sso" exact key={location.state && location.state.loginKey}>{() => <SsoLogin
        userToggle={userToggle}
        needsRegistration={(idToken,username) => assignState({needsRegistration: idToken, registrationValues: {username}})} system={system}/>}</Route>
      <Route path="/auth/:systemId" key={location.state && location.state.loginKey}>{() => <LoginForm
        userToggle={userToggle}
        needsRegistration={(idToken,username) => assignState({needsRegistration: idToken, registrationValues: {username}})} system={system}/>}</Route>
      <Route path="/auth" key={location.state && location.state.loginKey}>{() => <LoginForm
        userToggle={userToggle}
        needsRegistration={(idToken,username) => assignState({needsRegistration: idToken, registrationValues: {username}})} system={system}/>}</Route>
      <Route path="/login" key={location.state && location.state.loginKey}>{() => <LoginForm
        userToggle={userToggle}
        needsRegistration={(idToken,username) => assignState({needsRegistration: idToken, registrationValues: {username}})} system={system} autoLogin={autoLogin}/>}</Route>
      <Navigate to={"/"+(system ? '?systemId='+system.systemId : '')}/>
    </Routes>
  )
}
